import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/alkeon/Logo";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext"; // <-- Importiamo l'auth context

const Shell = ({ label, title, text, testid }) => (
  <main className="min-h-screen bg-ink flex items-center justify-center px-6 text-center" data-testid={testid}>
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.2 }} className="max-w-xl">
      <LogoMark className="w-10 h-10 text-sand mx-auto mb-10" />
      <p className="label mb-6">{label}</p>
      <h1 className="font-serif text-bone font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="payment-title">{title}</h1>
      <p className="body mt-8" data-testid="payment-message">{text}</p>
      <Link to="/" data-testid="payment-back-home" className="quiet-link mt-12 inline-flex"><span>Return to Atelier</span><span className="quiet-link-line" /></Link>
    </motion.div>
  </main>
);

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const { clear } = useCart();
  const { user } = useAuth(); // Se vuoi puoi anche rinfrescare l'utente

  useEffect(() => {
    if (!sessionId) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data?.payment_status === "paid") { 
          setState("paid"); 
          if (typeof clear === "function") clear(); 
          
          // FORZIAMO IL CHECK DELL'UTENTE AL RITORNO DA STRIPE
          try {
            await api.get("/auth/me");
          } catch {
            try {
              await api.post("/auth/refresh"); // Tenta il refresh silenzioso del token se scaduto
            } catch { /* ignora se resta ospite */ }
          }

          return; 
        }
        if (data?.status === "expired") { setState("error"); return; }
      } catch { /* retry */ }
      tries += 1;
      if (tries >= 10) { setState("pending"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, clear]);

  const copy = {
    checking: ["One moment", "Confirming your order…", "We are verifying the payment with our provider."],
    paid: ["Thank you", "Your piece is being prepared.", "A confirmation has been sent to your email. Each object is finished and packed by hand in the atelier."],
    pending: ["Pending", "Payment still processing.", "This can take a moment. You will receive an email as soon as it is confirmed."],
    error: ["Error", "We could not confirm this order.", "If you were charged, please contact us and we will resolve it promptly."],
  }[state];
  return <Shell testid="payment-success-page" label={copy[0]} title={copy[1]} text={copy[2]} />;
}

export function PaymentCancel() {
  return (
    <Shell
      testid="payment-cancel-page"
      label="Checkout Paused"
      title="The piece remains in the atelier — ready when you are."
      text="Your order was paused and no charges were made."
    />
  );
}